module.exports = __webpack_public_path__ + "static/media/merchandise_preview.b959e644.png";